// TODO: offices/utils.jsの移行先
import type {OfficeForAdmin} from 'types/api/offices/office'

export const getMainOfficeContactInfo = (office?: OfficeForAdmin) =>
  office?.office_contact_infos?.find((contactInfo) => contactInfo.office_contact_info_type === 'main_office_social')
